export const cardConfig = {
  empty: {
    // with base image
    true: {
      icon: 'image' as const,
      title: 'Select an image to use as a starting point',
      content:
        'Select one or more assets to get started. You can also search across the entire workspace for an image'
    },
    // without base image
    false: {
      icon: 'image' as const,
      title: 'Generate image',
      content: 'Enter a prompt below to generate your first image'
    }
  },
  error: {
    icon: 'error' as const,
    title: 'Could not generate image...',
    content:
      'Your prompt or generated image has been flagged for inappropriate content.'
  }
};
